import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppletHeaderQueryCriteriaClass extends BaseCriteriaModel {
  // hdr table
  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  applet_type?: Optional<string> = Optional.empty();

  // bl_applet_login_subject_link
  app_login_guid?: Optional<string> = Optional.empty();
  link_type?: Optional<string> = Optional.empty();

  // bl_applet_to_catalog_link
  catalog_hdr_guid?: Optional<string> = Optional.empty();

  //extension fields
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class AppletHeaderCriteriaModelQuery {
  query = '';

  constructor(appletHeaderCriteriaModel: AppletHeaderQueryCriteriaClass) {

    if (!appletHeaderCriteriaModel) {
      return;
    }

    this.query += appletHeaderCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.applet_type.filter(x => x !== '').map(x => '&applet_type=' + x).orElse('');

    this.query += appletHeaderCriteriaModel.app_login_guid.filter(x => x !== '').map(x => '&app_login_guid=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');

    this.query += appletHeaderCriteriaModel.catalog_hdr_guid.filter(x => x !== '').map(x => '&catalog_hdr_guid=' + x).orElse('');

    this.query += appletHeaderCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += appletHeaderCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += '&status=' + appletHeaderCriteriaModel.status;
    this.query += '&orderBy=' + appletHeaderCriteriaModel.orderBy;
    this.query += '&order=' + appletHeaderCriteriaModel.order;
    this.query += '&offset=' + appletHeaderCriteriaModel.offset + '&limit=' + appletHeaderCriteriaModel.limit;
  }
}
